export const InboxStatus = {
  None : 0,
  Open : 1,
  Processing : 2,
  Closed : 3,
}
